"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveVideoStatusMapper = void 0;
var enum_mapper_1 = require("../../utils/enum-mapper");
var globalTypes_1 = require("../generated/globalTypes");
var live_statuses_1 = require("@wix/wix-vod-constants/dist/common/live-statuses");
exports.liveVideoStatusMapper = new enum_mapper_1.EnumMapper((_a = {},
    _a[globalTypes_1.LiveStatus.DVR_PROCESSING] = live_statuses_1.LIVE_VIDEO_STATUS.FINISHED,
    _a[globalTypes_1.LiveStatus.STREAMING] = live_statuses_1.LIVE_VIDEO_STATUS.IN_PROGRESS,
    _a[globalTypes_1.LiveStatus.SCHEDULED] = live_statuses_1.LIVE_VIDEO_STATUS.SCHEDULED,
    _a[globalTypes_1.LiveStatus.FINISHED] = live_statuses_1.LIVE_VIDEO_STATUS.FINISHED,
    _a[globalTypes_1.LiveStatus.PENDING] = live_statuses_1.LIVE_VIDEO_STATUS.PENDING,
    _a[globalTypes_1.LiveStatus.RECONNECTING] = live_statuses_1.LIVE_VIDEO_STATUS.IN_PROGRESS,
    _a[globalTypes_1.LiveStatus.EXPIRED] = live_statuses_1.LIVE_VIDEO_STATUS.FINISHED,
    _a));
//# sourceMappingURL=live-video-status.js.map